import { isCalculatedPricing } from "./calculatedPricing";

// Named remote templates and arbitrary inline layouts have no verified CALC
// rendering contract. Owned reports convert rows into display-only fields first.
export function assertCalculatedPrintLayout(data) {
	const containsRawCalculation = value => {
		if (!value || typeof value !== "object" || value instanceof Date) return false;
		if (isCalculatedPricing(value)) return true;
		return Object.values(value).some(containsRawCalculation);
	};
	if (containsRawCalculation(data)) {
		throw new Error("This report layout does not support calculated amounts. Use the Structural Options report or the retail estimate report, which display the final amount only.");
	}
}
